/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/teacher.scss';
//component
//import PopMyInfoCard from '../../teacher/_PopMyinfoCard';
import PopConfirmInfo from '../../mypage/_PopConfirmInfo';
import PopLeave from '../../mypage/_PopLeave';
import PopSetIdNumber from '../../mypage/_PopSetIdNumber';
import PopAlert from '../../mypage/_PopAlert';
import Upload from '../../../component/Inc/Upload';

//image
import profileImg from 'contents/assets/img/profile_default.png';
import mapImg from 'contents/assets/img/img_map.png';
function TeacherManage() {
  const [modalLeaveOpen, setModalLeaveOpen] = useState(false);
  const [modalIdNumber, setModalIdNumber] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalAlert, setModalAlert] = useState(false);
  const [type, setType] = useState('id');
  const fnModal = (arg) => {
    if (arg === 'id') {
      setType('id_chg');
    } else if (arg === 'pw') {
      setType('pw');
    }
    setModalOpen(true);
  };
  return (
    <main className="com_container com_member_info p_teacher_info">
      {/* 20250218  퍼블 추가 & 수정 */}
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_1 active">
            교사 상세
            <span className="bar" />
            <span className="point_txt">홍교사103ㆍ수학</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            {/* 프로필 */}
            <div className="info_top teacher_profile">
              <div className="thumb">
                <img src={profileImg} alt="프로필 이미지" />
                <button className="btn_camera"></button>
              </div>
              <div className="com_input_wrap">
                <div className="input_row">
                  <input type="text" className="input" placeholder="교사명 (가명)" />
                  <input type="text" className="input" placeholder="교사명 (본명)" />
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">교사</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">담임</label>
                  </div>
                </div>
                <div className="input_row">
                  <input type="text" className="input" placeholder="" value="910101-*******" onClick={() => setModalIdNumber(true)} />
                  <div className="check check_gender">
                    <input type="radio" name="rdo_sex" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">남</label>
                    <input type="radio" name="rdo_sex" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">여</label>
                  </div>
                  <span className="com_bar"></span>
                  <div className="check">
                    <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                    <label htmlFor="chk04">대면</label>
                    <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                    <label htmlFor="chk05">화상</label>
                  </div>
                </div>
                <div className="input_row">
                  <select className="select">
                    <option value="본사">본사</option>
                    <option value="지사">지사</option>
                  </select>

                  <input type="text" className="input" placeholder="" value="전임교사 9" />
                  <div className="check">
                    <input type="radio" name="rdo_type" id="rdo06" className="com_chk circle" />
                    <label htmlFor="rdo06">정규직 </label>
                    <input type="radio" name="rdo_type" id="rdo07" className="com_chk circle" />
                    <label htmlFor="rdo07">프리랜서</label>
                    <input type="radio" name="rdo_type" id="rdo08" className="com_chk circle" />
                    <label htmlFor="rdo08">계약직</label>
                  </div>
                  <span className="com_bar"></span>
                  <div className="check">
                    <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                    <label htmlFor="chk03">상조회</label>
                  </div>
                </div>
              </div>
              <div className="btn_wrap">
                <div className="wrap">
                  <button className="com_btn orange xs btn_sms">채팅 하기</button>
                  <button className="com_btn orange xs btn_mail_white">메일 보내기</button>
                  <button className="com_btn black xs btn_plus_orange">면접 정보 보기</button>
                  <div className="com_switch_box bg">
                    <label className="switch_label">
                      <input type="checkbox" name="chk" id="chk010" className="com_switch" />
                      <span htmlFor="chk010" className="slider"></span>
                    </label>
                    <strong className="label">배정 제한</strong>
                  </div>
                </div>
                <div className="txt_right com_red_txt">배정대기: +468</div>
              </div>
            </div>
            {/* 상세 */}
            <div className="com_board_list__top end">
              <div className="check">
                <input type="checkbox" name="chk" id="chk12" className="com_chk" />
                <label htmlFor="chk12">특별관리</label>
              </div>
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="10%" />
                <col width="35%" />
                <col width="10%" />
                <col width="35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>아이디</th>
                  <td className="type_row">
                    <b>ase234@naver.com</b>
                    <button onClick={() => fnModal('id')} className="com_btn gray xs btn_change">
                      아이디 변경
                    </button>
                  </td>
                  <td colSpan={2}>
                    <div className="com_flex_row between">
                      <div className="com_flex_row gap_s">
                        <button className="com_btn orange xxs">화상</button>
                        <button className="com_btn gray xxs">대면</button>
                      </div>
                      <div className="com_flex_row">
                        보유포인트 <strong className="com_blue_txt">450</strong>
                        <span className="com_bar"></span>
                        필요 포인트 <strong className="com_blue_txt">120</strong>
                        <span className="com_bar"></span>
                        보유 가점 <strong className="com_blue_txt">13</strong>
                        <span className="com_bar"></span>
                        필요 가점 <strong className="com_blue_txt">10</strong>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>비밀번호</th>
                  <td className="type_row">
                    !@#**2344
                    <button
                      onClick={() => {
                        fnModal('pw');
                      }}
                      className="com_btn gray xs btn_change"
                    >
                      비밀번호 변경
                    </button>
                  </td>
                  <th rowSpan={2}>영역 상세</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="영어">영어</option>
                        <option value="국어">국어</option>
                      </select>
                      <input type="text" className="input" defaultValue={`B 캠페인 그룹`} />
                      <select className="select">
                        <option value="B 캠페인 그룹">B 캠페인 그룹</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>복합기아이디/비밀번호</th>
                  <td className="type_row">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`2245`} />
                      <input type="text" className="input" defaultValue={`2245`} />
                    </div>
                  </td>
                  <td>
                    <div className="check">
                      <input type="checkbox" name="chk" id="chk11" className="com_chk" />
                      <label htmlFor="chk11">수2 가능</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>휴대폰</th>
                  <td className="type_row">
                    <div className="input_list">
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="교폰">교폰</option>
                        </select>
                        <input type="text" className="input" defaultValue={`010-2322-2222`} />
                      </div>
                    </div>
                    <button className="com_btn gray xs btn_change">폰추가</button>
                  </td>
                  <th>중단 등급</th>
                  <td>
                    <input type="text" className="input ws" defaultValue={`9`} />
                  </td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" />
                    </div>
                  </td>
                  <th>시수</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <div className="check">
                        <input type="text" className="input" defaultValue={`44000 (선임3호봉)`} />
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01">특별시수</label>
                      </div>
                      <input type="text" className="input" defaultValue={`44,000`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>졸업증명서</th>
                  <td>
                    <div className="com_input_upload">
                      <Upload title="파일 등록" className="com_btn gray s wl" />
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </td>
                  <th>시수 구성</th>
                  <td>
                    <div className="com_flex_row">
                      지도관리 시수: <strong> 12,000</strong>
                      <span className="com_bar"></span>
                      원고료: <strong> 12,000</strong>
                      <span className="com_bar"></span>
                      장기 수업료: <strong> 12,000</strong>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>입사일</th>
                  <td>
                    <input type="date" className="com_datepicker" placeholder="입사일" />
                  </td>

                  <th>세부 계약 조건</th>
                  <td>
                    <input type="text" className="input" defaultValue={`시수 추가시 수강료 인상`} />
                  </td>
                </tr>
                <tr>
                  <th>계약일</th>
                  <td>
                    <input type="date" className="com_datepicker" placeholder="최종계약일" />
                  </td>
                  <th>계약서</th>
                  <td>
                    <div className="com_input_upload">
                      <Upload title="파일 등록" className="com_btn gray xs wl" />
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>면접/소개/컨택자</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="면접자">면접자</option>
                      </select>
                      <select className="select wm">
                        <option value="소개자">소개자</option>
                      </select>
                      <select className="select wm">
                        <option value="컨택자">컨택자</option>
                      </select>
                    </div>
                  </td>
                  <th rowSpan={2}>계약 히스토리</th>
                  <td rowSpan={2}>
                    <div className="txt">
                      ㆍ2023, 05, 12 ㅣ 퇴사 <br />
                      ㆍ2023, 07, 10 ㅣ 입사
                      <br />
                      ㆍ2023, 07, 10 ㅣ 입사
                      <br />
                      ㆍ2023, 07, 10 ㅣ 입사
                      <br />
                      ㆍ2023, 07, 10 ㅣ 입사
                      <br />
                      ㆍ2023, 07, 10 ㅣ 입사
                      <br />
                      <br />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th> 주소</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" placeholder="주소" />
                      <button className="com_btn gray xs">우편번호</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>상세주소</th>
                  <td>
                    <input type="text" className="input" placeholder="상세주소" />
                  </td>

                  <th>전임등급(진행중인 타임)</th>
                  <td>
                    <button className="com_btn gray xs">2024, 8월 전임교사</button>
                  </td>
                </tr>
                <tr>
                  <th>학력 / 전공</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`한국방송통신대`} />
                      <input type="text" className="input" defaultValue={`미디어영상학과`} />
                    </div>
                  </td>

                  <th rowSpan={2}>특별수수료 히스토리</th>
                  <td rowSpan={2}>
                    <div className="txt">
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수업 가능</th>
                  <td>
                    <div className="com_input_wrap">
                      <select className="select">
                        <option value="고3이상">고3이상</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>계좌 정보</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="하나은행">하나은행</option>
                      </select>
                      <input type="text" className="input ws" defaultValue={`홍길동`} />
                      <input type="text" className="input wl" defaultValue={`828282918292`} />
                    </div>
                  </td>
                  <th rowSpan={2}>특별수수료 히스토리</th>
                  <td rowSpan={2}>
                    <div className="txt">
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                      ㆍ2023, 05, 12 ㅣ 5,000 ㅣ 김관리123
                      <br />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>경력 & 메모</th>
                  <td>
                    <div className="txt_memo">메모메모메모</div>
                  </td>
                </tr>
                <tr>
                  <th>보증보험 가입증서</th>
                  <td>
                    <div className="com_input_upload">
                      <Upload title="파일 등록" className="com_btn gray xs wl" />
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </td>
                  <th>강사성향</th>
                  <td>
                    <input type="text" />
                  </td>
                </tr>
                <tr>
                  <th rowSpan={2}>교육 수료 목록</th>
                  <td rowSpan={2}>
                    <div className="txt">
                      <p>
                        <span className="item_txt point">ㆍ2023 교사교육 / 2023,05,16 ~2023, 07, 05 / 수료</span>
                      </p>
                      <p>
                        <span className="item_txt">ㆍ2022 교사교육 교사 교육 / 수료</span>
                      </p>
                      <p>
                        <span className="item_txt">ㆍ2021 교사 대표교사 / 포기</span>
                      </p>
                      <p>
                        <span className="item_txt">ㆍ2022 교사교육 교사 교육 / 수료</span>
                      </p>
                      <p>
                        <span className="item_txt">ㆍ2021 교사 대표교사 / 포기</span>
                      </p>
                      <p>
                        <span className="item_txt">ㆍ2022 교사교육 교사 교육 / 수료</span>
                      </p>
                      <p>
                        <span className="item_txt">ㆍ2021 교사 대표교사 / 포기</span>
                      </p>
                    </div>
                  </td>
                  <th>강점학년</th>
                  <td>
                    <input type="text" />
                  </td>
                </tr>
                <tr>
                  <th>강점등급</th>
                  <td>
                    <input type="text" />
                  </td>
                </tr>
                <tr className="tr_wish">
                  <th>수업 희망 요일</th>
                  <td>
                    <button className="btn_day active">월</button>
                    <button className="btn_day">화</button>
                    <button className="btn_day">수</button>
                    <button className="btn_day">목</button>
                    <button className="btn_day">금</button>
                    <button className="btn_day">토</button>
                    <button className="btn_day">일</button>
                  </td>
                  <td rowSpan={2} colSpan={2} className="td_notice">
                    ㆍ최소 3개 이상 (1순위1개, 2순위2개)지역을 선택해야 합니다. <br />
                    ㆍ신규 교사는 거주지와 원거리 지역이 기본 선택 되어있습니다. 1년 후 수정 가능합니다. <br />
                    ㆍ거주지 이동시 희망 지역을 변경해야 합니다. <br />
                    ㆍ원거리 : 2순위에서 접하지 않은 지역.
                  </td>
                </tr>
                <tr className="tr_wish">
                  <th>수업 희망 지역</th>
                  <td>
                    <span className="com_check_box">
                      <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                      <label htmlFor="chk010">원거리 강의 가능</label>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* 지역 */}
            <div className="area_wrap">
              <div className="area_select">
                <div className="select_row">
                  <div className="city">
                    <select className="select">
                      <option value="서울">서울</option>
                      <option value="경기도">경기도</option>
                    </select>
                  </div>
                  <div className="rank">
                    <p className="rank_txt">1순위</p>
                  </div>
                  <div className="detail_area">
                    <div className="check">
                      <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk" />
                      <label htmlFor="chk_area_01">전체</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강남구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강남구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강남구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강동구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강북구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">강서구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">관악구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광진구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구로구</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">금천구</label>
                    </div>
                  </div>
                </div>
                <div className="select_row">
                  <div className="city">
                    <select className="select">
                      <option value="경기도">경기도</option>
                      <option value="서울">서울</option>
                    </select>
                  </div>
                  <div className="rank">
                    <p className="rank_txt">2순위</p>
                  </div>
                  <div className="detail_area">
                    <div className="check">
                      <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk" />
                      <label htmlFor="chk_area_01">전체</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">고양시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">과천시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광명시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구리시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">군포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">김포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">남양주시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">부천시</label>
                    </div>
                  </div>
                </div>
                <div className="select_row">
                  <div className="city">
                    <select className="select">
                      <option value="경기도">경기도</option>
                      <option value="서울">서울</option>
                    </select>
                  </div>
                  <div className="rank">
                    <p className="rank_txt">2순위</p>
                  </div>
                  <div className="detail_area">
                    <div className="check">
                      <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk" />
                      <label htmlFor="chk_area_01">전체</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">고양시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">과천시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">광명시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">구리시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">군포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">김포시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">남양주시</label>
                      <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk" />
                      <label htmlFor="chk_area_02">부천시</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="leaving_wrap">
              <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
              <label htmlFor="chkAll">
                <strong>전체동의</strong>
              </label>
              <ul className="policy_list">
                <li className="item">
                  <input type="checkbox" name="chk" id="policy1" className="com_chk" />
                  <label htmlFor="policy1">[필수] 이용약관</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
                <li className="item">
                  <input type="checkbox" name="chk" id="policy2" className="com_chk" />
                  <label htmlFor="policy2">[필수] 개인정보 수집 및 이용에 대한 안내</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
                <li className="item">
                  <input type="checkbox" name="chk" id="policy3" className="com_chk" />
                  <label htmlFor="policy3">[필수] 개인정보 제 3자 제공 동의사항</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
                <li className="item">
                  <input type="checkbox" name="chk" id="policy4" className="com_chk" />
                  <label htmlFor="policy4">[필수] 보증보험 가입 동의서</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
                <li className="item">
                  <input type="checkbox" name="chk" id="policy5" className="com_chk" />
                  <label htmlFor="policy5">[필수] 개인간 계약서</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
                <li className="item">
                  <input type="checkbox" name="chk" id="policy6" className="com_chk" />
                  <label htmlFor="policy6">[필수] 성범죄 경력 조회 동의서</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
                <li className="item">
                  <input type="checkbox" name="chk" id="policy7" className="com_chk" />
                  <label htmlFor="policy7">상조회 급여공제 규정</label>
                  <button className="btn_link blue">내용보기</button>
                </li>
              </ul>
              <button className="com_btn gray xxs line btn_change" onClick={() => setModalLeaveOpen(true)}>
                퇴사하기
              </button>
            </div>
						 <hr className="com_divider"/>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s" onClick={() => setModalAlert(true)}>
                저장
              </button>
              <button className="com_btn line gray s btn_enter">재입사</button>
            </div>
          </div>
        </section>
      </div>
      {/*<PopMyInfoCard open={modalOpen} close={() => setModalOpen(false)} />*/}
      <PopConfirmInfo open={modalOpen} close={() => setModalOpen(false)} type={type} />
      <PopLeave open={modalLeaveOpen} close={() => setModalLeaveOpen(false)} />
      <PopSetIdNumber open={modalIdNumber} close={() => setModalIdNumber(false)} />
      <PopAlert
        open={modalAlert}
        close={() => setModalAlert(false)}
        text={
          <>
            변경이 완료되었습니다.
            <br />
            <br />
            변경된 정보로
            <br />
            다시 로그인 해 주세요.
          </>
        }
      />
    </main>
  );
}

export default TeacherManage;
